import { Observable, of } from 'rxjs'
import { CanActivate, CanLoad, Route } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { IsDataLoaded } from '@tokeet/tv3-platform'
import { selectLosDiscountsLoaded } from '../store/los-discount/los-discount.selectors'
import { LoadLosDiscounts } from '../store/los-discount/los-discount.actions'

@Injectable({ providedIn: 'root' })
export class LosDiscountGuard implements CanActivate, CanLoad, IsDataLoaded {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectLosDiscountsLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(LoadLosDiscounts({}))
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
